import { render, staticRenderFns } from "./LoadPage.vue?vue&type=template&id=0cbbfb74&functional=true&"
import script from "./LoadPage.vue?vue&type=script&lang=js&"
export * from "./LoadPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports